import React from "react";



const BottomPageGradient = () => {
  return (
    <>
      {/* First radial glow - bottom left */}
      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          bottom: "-200px",
          left: "-100px",
          background:
            "radial-gradient(circle, #5442b9 0%, transparent 30%)",
          filter: "blur(80px)",
          zIndex: 0,
        }}
      />

      {/* Second radial glow - mid left */}
      <div
        style={{
          position: "absolute",
          width: "250px",
          height: "250px",
          top: "50%",
          left: "-150px",
          background:
            "radial-gradient(circle, #5442b9 0%, transparent 30%)",
          filter: "blur(50px)",
          zIndex: 0,
        }}
      />
    </>
  );
};

export default BottomPageGradient;
